import { createSSRApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import {createAppRouter} from './routing'
import 'ant-design-vue/dist/reset.css';
import '@/assets/styles/main.scss';
import Widget from './widget/Declaration';
import '@/assets/styles/font.scss';
import Vue3SocialSharingPlugin from "vue3-social-sharing";
import { createHead } from '@vueuse/head'
import OneSignalVuePlugin from '@onesignal/onesignal-vue3';
import * as Sentry from "@sentry/vue";

const vue = createSSRApp(App)
const router = createAppRouter()

Sentry.init({
  app: vue,
  dsn: "https://f9eNcsf9yGRkBLDa9fitnKPD@s2472000.eu-fsn-3.betterstackdata.com/2472000",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: true,
      },
    }),
  ],
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
});

vue.use(Widget)
vue.use(Antd)
vue.use(router)
vue.use(createHead())

vue.use(Vue3SocialSharingPlugin);
vue.use(OneSignalVuePlugin, {
  appId: "7a6b6929-85b0-424e-8216-1f033667ea4f",
})

vue.mount('#app')